import * as React from "react";
import "./SectionLinkComponent.css";
import { Intent, ProgressBar } from "@blueprintjs/core";
import { HRSectionId } from "../../messages/ObjectIds";
import { getHeaderTextFontSize } from "../GenericSectionsList";

interface SectionLinkComponentProps {
    sectionId: HRSectionId | 0;
    isClicked: boolean;
    status: number;
    title: string;
    onClick: () => void;
    sectionCount: number;
    isLocked: boolean;
}

export class SectionLinkComponent extends React.Component<SectionLinkComponentProps> {
    constructor(props: SectionLinkComponentProps) {
        super(props);
    }

    render() {
        return (
            <div onClick={this.props.onClick}>
                <div
                    className={"SectionLinkComponent__LinkContainer " +
                    (this.props.isClicked ? "SectionLinkComponent__LinkContainerClicked" : "")}
                >

                    <div>
                        <div className="SectionLinkComponent__lockContainer">
                            {this.props.isLocked ? (<i className="fa fa-lock" />)
                                : null
                            }
                        </div>
                        <h4
                            className={"SectionLinkComponent__header " + (this.props.isClicked ? "SectionLinkComponent__headerClicked" : "")}
                        // style={{
                        //     fontSize: getHeaderTextFontSize(this.props.sectionCount)
                        // }}
                        >
                            {this.props.title}
                        </h4>
                    </div>

                    <ProgressBar
                        className={"bp3-no-stripes SectionLinkComponent__progBar " + (this.props.isClicked ? "bp3-progress-bar-clicked" : "")}
                        intent={Intent.PRIMARY}
                        value={this.props.status / 100}
                        stripes={false}
                        animate={false}
                    />
                    <div
                        className={"SectionLinkComponent__bottom " + (this.props.isClicked ? "SectionLinkComponent__headerClicked" : "")}
                        // style={{
                        //     fontSize: getHeaderTextFontSize(this.props.sectionCount)
                        // }}
                    >
                        {this.props.status}% complete
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/SectionLinkComponent.tsx